module.exports = __webpack_public_path__ + "static/media/2DGACM9.f162a4cc.jpg";